/**
 * Function to get the data attribute that is compatible with IE
 * @param element
 * @param attributeName
 */
export function getDataAttribute(element, attributeName) {
    if (!element || !attributeName) return null;
    return element.dataset ? element.dataset[attributeName] : element.getAttribute(`data-${attributeName}`);
}

export function setDataAttribute(element, attributeName, value) {
    if (!element || !attributeName || !value) return null;
    if (element.dataset) {
        element.dataset[attributeName] = value;
    } else {
        element.setAttribute(`data-${attributeName}`, value);
    }
    return 1;
}

/**
 * Function to get window.location.origin that is compatible with IE 9/10
 */
export function getWindowLocationOrigin() {
    if (!window.location.origin) {
        const port = (window.location.port ? `:${window.location.port}` : '');
        window.location.origin = `${window.location.protocol}//${window.location.hostname}${port}`;
        return window.location.origin;
    }
    return window.location.origin;
}



/** WEBPACK FOOTER **
 ** ./app/scripts/utils/compatibilityUtils.js
 **/